module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon02.6bb64c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon02.png
// module id = mozr
// module chunks = 0